import React from 'react'
import { PageHeaderPeriodPickerProps } from './PageHeaderPeriodPicker.types'
import styles from './PageHeaderPeriodPicker.module.scss'
import cl from 'classnames'
import { Text1 } from '../Text1'
import { Select } from '../Select'
import { FilterPeriods } from 'store'
import { PeriodPicker } from 'components/common'

const PageHeaderPeriodPickerComponent = (props: PageHeaderPeriodPickerProps) => {
  const {
    className,
    style,
    selectProps,
    periodPickerProps
  } = props

  return (
    <div
      className={cl(styles.periodPickerContainer, className)}
      style={style}
    >
      <Text1>Period</Text1>
      <Select<FilterPeriods>
        className={styles.periodInput}
        {...selectProps}
      />
      <PeriodPicker
        noIcon
        label=''
        size='mini'
        placeholder='Custom'
        className={styles.customPeriodPicker}
        {...periodPickerProps}
      />
    </div>
  )
}

const PageHeaderPeriodPicker = PageHeaderPeriodPickerComponent
export { PageHeaderPeriodPicker }
